import { render, staticRenderFns } from "./CashRegisterDialog.vue?vue&type=template&id=2bb0c070"
import script from "./CashRegisterDialog.vue?vue&type=script&lang=js"
export * from "./CashRegisterDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports